import React, { FC, HTMLAttributes, memo } from 'react';
import { Header as CarbonHeader } from '@carbon/react';
import { useWorkspace } from '@/workspace';
import { RapidaIcon } from '@/app/components/Icon/Rapida';
import { RapidaTextIcon } from '@/app/components/Icon/RapidaText';

interface HeaderProps extends HTMLAttributes<HTMLDivElement> {}
export const Header: FC<HeaderProps> = memo(({ ...attr }) => {
  const workspace = useWorkspace();
  return (
    <CarbonHeader
      aria-label={workspace.title}
      className="border-gray-200! dark:border-gray-900! p-7!"
    >
      <div className="ml-1 flex shrink-0 items-center space-x-1.5 text-blue-600 dark:text-blue-500">
        {workspace.logo ? (
          <>
            <img
              src={workspace.logo.light}
              alt={workspace.title}
              className="h-8 block dark:hidden"
            />
            <img
              src={workspace.logo.dark}
              alt={workspace.title}
              className="h-8 hidden dark:block"
            />
          </>
        ) : (
          <div className="flex items-center gap-2">
            <RapidaIcon className="h-8 w-auto shrink-0" />
            <RapidaTextIcon className="h-6 w-auto" />
          </div>
        )}
      </div>
    </CarbonHeader>
  );
});
